import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import { withRouterPath, InjectedProps as WithRouterPathProps } from 'platform-components/hocs';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose, Dispatch } from 'redux';

import LessonLoader from 'common.components/lesson-loader/lesson-loader';
import * as lessonViewActions from 'common.components/lesson-view.store/actions';
import NoLessonsPane from 'common.components/no-lessons-pane/no-lessons-pane';
import { actions as coursesActions } from 'store/courses/actions';
import * as likesSelectors from 'store/likes/selectors';

import { ReduxTeacherStore, RootAction } from '../../../typings';
import * as actions from '../actions';
import * as selectors from '../selectors';

type StoreProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;

interface OwnProps extends WithRouterPathProps {
    courseId: number | null;
    shouldRenderEmptyMessage?: boolean;
}

interface CompletedLoaderProps extends OwnProps, StoreProps, DispatchProps {}

export class CompletedLoader extends React.Component<CompletedLoaderProps> {
    loadLessons = () => {
        const { courseId } = this.props;

        if (!courseId) {
            return;
        }

        const { getLessonsRequest, getLessonsCountRequest } = this.props;

        getLessonsRequest(courseId, (clessons) => {
            const { getClessonReactions, classId, subject } = this.props;
            getClessonReactions(clessons, classId, subject);
        });
        getLessonsCountRequest({ courseId });
    };

    handleLessonClick = () => {
        const { toggleLessonModal } = this.props;

        toggleLessonModal(true);
    };

    render() {
        const {
            courseId,
            loadingStatus,
            shouldLoadLessons,
            lessons,
            shouldRenderEmptyMessage,
            shouldShowLikes,
            clessonLikes,
        } = this.props;
        const shoudShowNoLessonsPane =
            loadingStatus === LOADING_STATUSES.SUCCESS && lessons.length === 0 && shouldRenderEmptyMessage;

        if (!courseId) {
            return null;
        }

        return (
            <>
                {shoudShowNoLessonsPane && <NoLessonsPane titleId="courseView.completedLessons.noLessonsPane.text" />}
                <LessonLoader
                    canEditLessons={true}
                    clessonLikes={clessonLikes}
                    courseId={courseId}
                    getNextPageRequest={this.loadLessons}
                    lessons={lessons}
                    loadingStatus={loadingStatus}
                    onLessonClick={this.handleLessonClick}
                    shouldLoadLessons={shouldLoadLessons}
                    shouldShowLikes={shouldShowLikes}
                />
            </>
        );
    }
}

const mapStateToProps = (storeState: ReduxTeacherStore, ownProps: OwnProps) => {
    const {
        courseId,
        match: { params },
    } = ownProps;
    const classId = Number(params?.classId) || null;
    const subject = params?.subject || null;

    return {
        classId,
        subject,
        loadingStatus: selectors.getCompletedLessonsLoadingStatus(storeState, { courseId }),
        shouldLoadLessons: selectors.getShouldLoadCompletedLessons(storeState, { courseId }),
        lessons: selectors.getCompletedLessons(storeState, { courseId }),
        shouldShowLikes: likesSelectors.getShouldShowLikeReactions(storeState, { classId, subject }),
        clessonLikes: likesSelectors.getClessonTotalLikes(storeState),
    };
};

const mapDispatchToProps = (dispatch: Dispatch<RootAction>) => {
    const { getCompletedLessonsRequest, getClessonReactionsRequest } = actions;
    const { getLessonsCountRequest } = coursesActions;
    const { toggleModal } = lessonViewActions;

    return bindActionCreators(
        {
            getLessonsRequest: getCompletedLessonsRequest,
            getLessonsCountRequest,
            toggleLessonModal: toggleModal,
            getClessonReactions: getClessonReactionsRequest,
        },
        dispatch
    );
};

export default compose<any>(withRouterPath, connect(mapStateToProps, mapDispatchToProps))(CompletedLoader);
